import { PURCHASE_REQUEST_AUDITS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/purchase_request_audits_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['purchaseRequestAuditsIndex']);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
